import React, { useState } from 'react';
import './servicesPage.scss';
import { content } from './data'
import List from 'devextreme-react/list';
 
export default function servicesPage() {
    return (
        <>
            <div className="services-page">
                <h2 className="section-heading-services">SERVICES</h2>
                <div className="list-container">
                    <List
                        dataSource={content}
                        height="100%"
                        itemRender={(data) => (
                            <div className="card-view-services">
                                <img src={data.image} alt={data.name} className="list-image" />
                                <h4 className="text-style-h4">{data.title}</h4>
                                <p>{data.description}</p>
                            </div>
                        )}
                        activeStateEnabled={false}
                    />
                </div>
            </div>
        </>
    )
}


